import React, { useState, useRef, useEffect } from 'react';

const CustomSelect = ({
  options = [],
  value,
  onChange,
  placeholder = 'Select...',
  className = ''
}) => {
  const [open, setOpen] = useState(false);
  const [highlight, setHighlight] = useState(-1);
  const ref = useRef(null);

  const selected = options.find(o => o.value === value);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const handleKeyDown = (e) => {
    if (!open && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      setOpen(true);
      setHighlight(Math.max(0, options.findIndex(o => o.value === value)));
      return;
    }
    if (open) {
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); setHighlight(h => Math.min(options.length - 1, (h + 1))); }
      if (e.key === 'ArrowUp') { e.preventDefault(); setHighlight(h => Math.max(0, (h - 1))); }
      if (e.key === 'Enter') {
        e.preventDefault();
        if (options[highlight]) {
          onChange && onChange(options[highlight].value);
          setOpen(false);
        }
      }
    }
  };

  return (
    <div ref={ref} className={`relative ${className}`} onKeyDown={handleKeyDown}>
      <button
        type="button"
        className="w-full px-4 py-2 bg-white rounded-lg border shadow-sm text-left flex items-center justify-between hover:bg-gray-50 focus:bg-gray-50"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="text-[color:var(--color-text)]">
          {selected ? selected.label : placeholder}
        </span>
        <span className="ml-2" aria-hidden="true">▾</span>
      </button>
      {open && (
        <ul
          className="absolute z-20 left-0 right-0 top-full mt-1 max-h-60 overflow-auto rounded-md border bg-white shadow-lg"
          role="listbox"
        >
          {options.map((opt, idx) => {
            const isSelected = value === opt.value;
            const isHighlight = idx === highlight;
            return (
              <li
                key={opt.value}
                role="option"
                aria-selected={isSelected}
                className={`px-4 py-2 cursor-pointer text-[color:var(--color-text)] ${
                  isSelected || isHighlight ? 'bg-[color:var(--color-warn)]' : ''
                }`}
                onMouseEnter={() => setHighlight(idx)}
                onClick={() => { onChange && onChange(opt.value); setOpen(false); }}
              >
                {opt.label}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;
